export default "__VITE_PUBLIC_ASSET__c8228dcf__"